import { isURL } from 'validator';

const getProcessEnvVar = envVar => process.env[envVar] || '';

const getWindowEnvVar = envVar => (window && window.env && window.env[envVar] ? window.env[envVar] : '');

const getEnvVar = (envVar) => {
  if (process.env.NODE_ENV === 'development') {
    return getProcessEnvVar(envVar);
  }
  return getWindowEnvVar(envVar) || getProcessEnvVar(envVar);
};

const getBooleanEnvVar = envVar => String(getEnvVar(envVar)).toLowerCase() === 'true';

const validateDomain = (domain, envVarName = 'DOMAIN') => {
  if (domain) {
    const isValidURL = isURL(domain, {
      allow_protocol_relative_urls: true,
      require_host: false,
      require_tld: false,
      require_protocol: false,
    });
    if (!isValidURL) {
      throw new Error(`The ${envVarName} env variable is invalid.`);
    }
    return domain.replace(/\/+$/, '');
  }
  return '';
};

export default () => ({
  COMPONENT_REPOSITORY_UI_ENABLED: getBooleanEnvVar('COMPONENT_REPOSITORY_UI_ENABLED'),
  DOMAIN: validateDomain(getEnvVar('DOMAIN')),
  // Overrides the host/path used for the component-manager (`/digital-exchange`) API.
  // When empty it falls back to the `/digital-exchange` path on the DOMAIN host.
  COMPONENT_MANAGER_URL: validateDomain(getEnvVar('COMPONENT_MANAGER_URL'), 'COMPONENT_MANAGER_URL'),
  KEYCLOAK_JSON: getEnvVar('KEYCLOAK_JSON') || `${validateDomain(getEnvVar('DOMAIN'))}/keycloak.json`,
});
